import { forwardRef } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogProps,
  Typography,
} from '@spazious/dollhouse-uikit';

import { CloseButton } from '../CloseButton/index.js';

import { ConfirmDialogActions, ConfirmDialogActionsProps } from './ConfirmDialogActions.js';

export interface ConfirmDialogProps
  extends Omit<OverrideProps<DialogProps, ConfirmDialogActionsProps>, 'title' | 'content'> {
  title?: React.ReactNode;
  content: React.ReactNode;
  showCloseIcon?: boolean;
  showCloseButton?: boolean;
}

export const ConfirmDialog = forwardRef<HTMLDivElement, ConfirmDialogProps>(
  (
    {
      title = 'Are you sure?',
      content,
      setting,
      invertedSetting,
      showCloseIcon = true,
      showCloseButton = false,
      onClose,
      onConfirm,
      ...restProps
    },
    forwardedRef
  ) => {
    return (
      <Dialog
        ref={forwardedRef}
        // TODO implement macros in shared package
        {...(restProps as any)}
        onClose={onClose as DialogProps['onClose']}
      >
        <DialogHeader>
          <Typography size="medium" variant="headline">
            {title}
          </Typography>
          {showCloseIcon && <CloseButton onClick={(evt) => onClose?.(evt, 'btnCancelClick')} />}
        </DialogHeader>
        <DialogContent>{content}</DialogContent>
        <ConfirmDialogActions
          invertedSetting={invertedSetting}
          setting={setting}
          showCloseButton={showCloseButton}
          onClose={onClose}
          onConfirm={onConfirm}
          {...restProps}
        />
      </Dialog>
    );
  }
);
